import React from 'react'
import Banner from './banner'
import {
  Box,
} from '@mui/material';
import About from './About';
import Gallery from './Gallery';
import MasterLayout from './MasterLayout';
import FloorPlans from './FloorPlans';
import Amenities from './Amenities';
import ConntedLiving from './ConntedLiving';
import ContactSection from './ContactSection';

const index = () => {
  return (
    <Box>
      <Banner/>
      <About/>
      <Gallery/>
      <MasterLayout/>
      <FloorPlans/>
      <Amenities/>
      <ConntedLiving/>
      <ContactSection/>
      
    </Box>
  )
}

export default index
